// PostHeader.js
import React from "react";
import { Avatar, Box, Chip, Typography, Stack } from "@mui/material";
import { formatDate } from '../../../utils/helpers';
import { motion } from 'framer-motion';

const PostHeader = ({ post }) => {
  return (
    <Box mb={4}>
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        sx={{
          fontWeight: 700,
          color: "#212121",
          fontSize: { xs: "1.5rem", md: "1.75rem" },
        }}
      >
        {post.title}
      </Typography>

      <Stack direction="row" spacing={2} alignItems="center" mb={2}>
        <Avatar
          src={post?.author?.profilePic?.url}
          alt={post?.author?.name}
          sx={{ width: 56, height: 56 }}
        />
        <Box>
          <Typography variant="subtitle1" fontWeight={600} sx={{ color: "#212121", fontSize: "0.95rem" }}>
            {post?.author?.name}
          </Typography>
          <Typography variant="body2" sx={{ color: "#616161", fontSize: "0.85rem" }}>
            Posted on {formatDate(post.createdAt)}
          </Typography>
        </Box>
      </Stack>

      <Stack direction="row" spacing={1} mb={3} flexWrap="wrap" rowGap={1}>
        <motion.div whileHover={{ scale: 1.05 }}>
          <Chip
            label={`₹${post.rent}/month`}
            sx={{
              fontWeight: 600,
              fontSize: "0.85rem",
              borderColor: "#001d3d",
              color: "#001d3d",
              backgroundColor: "#fff",
            }}
            variant="outlined"
          />
        </motion.div>

        <Chip
          label={post.location}
          sx={{
            backgroundColor: "#001d3d",
            color: "#fff",
            fontWeight: 500,
            fontSize: "0.85rem",
          }}
        />

        <Chip
          label={`Available from ${formatDate(post.availableFrom)}`}
          sx={{
            borderColor: "#001d3d",
            color: "#001d3d",
            backgroundColor: "#fff",
            fontWeight: 500,
            fontSize: "0.85rem",
          }}
          variant="outlined"
        />
      </Stack>
    </Box>
  );
};

export default PostHeader;
